import React from 'react';
import './Resume.css';

const AWARDS = [
  { text: 'Best Costume Design, SF Bay Area Theatre Critics Circle Award — "5 & Dime, Come Back Jimmy Din"', year: '2025' },
  { text: 'Exhibition: "Crossroads. Support Ukraine" — USC Doheny Memorial Library', year: '' },
  { text: 'Exhibition: Costume Design for "La Boheme", OSJ — San Jose Museum of Quilts and Textiles', year: '2019' },
  { text: 'Nomination, Best Costume Design, SF Bay Area Theatre Critics Circle Award — "Timon of Athens"', year: '2018' },
  { text: 'Nomination, Best Costume Design, SF Bay Area Theatre Critics Circle Award — "Hedda Gabler"', year: '2017' },
  { text: 'International Exhibition: "Costume Design at the Turn of the Century, 1990–2015" — Bakhrushin Museum, Moscow', year: '2015' },
  { text: 'Outstanding Costume Design, San Diego Critics Circle, Craig Noel Award — "School for Lies"', year: '2014' },
  { text: 'Nomination, Outstanding Costume Design, San Diego Critics Circle, Craig Noel Award — "Fallen Angels"', year: '2014' },
  { text: 'Prague Quadrennial — "El Camino Real"', year: '2011' },
  { text: 'Excellence in Teaching, UC San Diego', year: '2011' },
  { text: 'KPBS Patté Award, Outstanding Costume Design', year: '2009' },
  { text: 'Excellence in Technical Theatre Program, Crafton Hills College', year: '2007' },
];

const PRODUCTIONS = [
  { year: '2026', items: [
    { title: 'Alice in Wonderland', venue: 'Presidio Theatre', director: 'Liam Vincent' },
    { title: '5 & Dime', venue: 'TheatreWorks Silicon Valley', director: 'Giovanna Sardelli' },
    { title: 'Harvey Milk', venue: 'Opera Parallèle', director: 'Brian Staufenbiel' },
  ]},
  { year: '2025', items: [
    { title: 'Peter Pan (Panto)', venue: 'Presidio Theatre', director: 'Liam Vincent' },
    { title: '5 & Dime', venue: 'TheatreWorks Silicon Valley', director: 'Giovanna Sardelli' },
    { title: 'Harvey Milk', venue: 'Opera Parallèle', director: 'Brian Staufenbiel' },
  ]},
  { year: '2024', items: [
    { title: 'Peter Pan (Panto)', venue: 'Presidio Theatre', director: 'Liam Vincent' },
    { title: 'La Bohème', venue: 'Opera San Jose', director: 'Michelle Cuizon' },
    { title: 'Cancelina', venue: 'Potiker Theatre', director: 'Allie Moss' },
    { title: '809 Almond', venue: 'Potiker Theatre', director: 'Stephen Buescher' },
  ]},
  { year: '2023', items: [
    { title: 'Sleeping Beauty (Panto)', venue: 'Presidio Theatre', director: 'Liam Vincent' },
    { title: 'The Shining', venue: 'Opera Parallèle', director: 'Brian Staufenbiel' },
  ]},
  { year: '2022', items: [
    { title: 'Sleeping Beauty (Panto)', venue: 'Presidio Theatre', director: 'Liam Vincent' },
  ]},
  { year: '2021', items: [
    { title: 'The Magic Lamp (Panto)', venue: 'Presidio Theatre', director: 'Bryan Torfeh' },
    { title: 'Katya Kabanova', venue: 'West Edge Opera', director: 'Indre Viscontas' },
    { title: 'Coded', venue: 'City Lights Theatre', director: 'Kirsten Brandt' },
  ]},
  { year: '2020', items: [
    { title: 'Aladdin (Panto video)', venue: 'Presidio Theatre', director: 'Peggy Haas' },
    { title: 'Mazzoli Vespers (music video)', venue: 'Sun Valley Music Festival', director: 'Brian Staufenbiel' },
  ]},
  { year: '2019', items: [
    { title: 'If I Were You', venue: 'San Francisco Opera', director: 'Keturah Stickann Doucet' },
    { title: 'Today it Rains', venue: 'Opera Parallèle', director: 'Brian Staufenbiel' },
  ]},
  { year: '2018', items: [
    { title: 'Uncle Vanya', venue: 'Cutting Ball Theatre', director: 'Paige Rogers' },
    { title: 'Pelléas and Mélisande', venue: 'West Edge Opera', director: 'Keturah Stickann Doucet' },
    { title: 'Timon of Athens', venue: 'Cutting Ball Theatre', director: 'Rob Melrose' },
    { title: 'Iron Shoes', venue: 'Shotgun Players', director: 'Erika Chong Chuch' },
  ]},
  { year: '2017', items: [
    { title: 'The Many Faces of Farce', venue: 'Stanford Repertory Theatre', director: 'Alex Johnson' },
    { title: 'La Bohème', venue: 'Opera San Jose', director: 'Michael Shell' },
    { title: 'Calligraphy', venue: 'TheatreWorks', director: 'Leslie Martinson' },
    { title: 'Flight', venue: 'Opera Parallèle', director: 'Brian Staufenbiel' },
    { title: 'Hedda Gabler', venue: 'Cutting Ball Theatre', director: 'Yury Urnov' },
  ]},
  { year: '2016', items: [
    { title: 'Waiting for Lefty', venue: 'Stanford Repertory Theatre', director: 'Marty Pistone' },
    { title: 'Slaughter City', venue: 'Stanford Repertory Theatre', director: 'Alex Johnson' },
    { title: 'Fences', venue: 'California Shakespeare Company', director: 'Raelle Myrick-Hodges' },
    { title: 'Way Downriver', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Tokyo Fish Story', venue: 'TheatreWorks', director: 'Kirsten Brandt' },
  ]},
  { year: '2015', items: [
    { title: 'Betrayal', venue: 'North Coast Rep Theatre', director: 'Frank Corrado' },
    { title: 'Unnecessary Farce', venue: 'North Coast Rep Theatre', director: 'Matthew Wiener' },
    { title: 'The Threepenny Opera', venue: 'UC San Diego Music Dept.', director: 'Ruff Yeager' },
    { title: 'Chapter Two', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Twilight, Los Angeles: 1992', venue: 'San Marcos State University', director: 'Kaja Dun' },
  ]},
  { year: '2014', items: [
    { title: 'Scapin', venue: 'Grossmont Community College', director: 'Brian Rickel' },
    { title: 'Gunmetal Blues', venue: 'North Coast Rep Theatre', director: 'Andrew Barnicle' },
    { title: 'Rent', venue: 'School of Creative and Performing Arts', director: 'Bill Doyle' },
    { title: "Freud's Last Session", venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Fallen Angels', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Regrets Only', venue: 'Diversionary Theatre', director: 'Jessica John' },
    { title: 'Romance, Romance', venue: 'North Coast Rep Theatre', director: 'Rick Simas' },
    { title: 'Agrippina', venue: 'Opera NEO', director: 'Peter Kozma' },
    { title: 'Magic Flute', venue: 'Opera NEO', director: 'Octavio Cardenas' },
    { title: 'Mandate Memory', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Bird Lady', venue: 'Link Theatre / Chicago', director: 'Rebecca Salzer' },
    { title: 'Seussical, the Musical', venue: 'San Marcos State University', director: 'Kaja Dun' },
    { title: 'Playwrights Project', venue: 'Old Globe Theatre', director: 'George Ye, Rosina Rainold' },
    { title: 'School for Lies', venue: 'North Coast Rep Theatre', director: 'Andrew Paul' },
  ]},
  { year: '2013', items: [
    { title: 'Broken Glass', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Pause', venue: 'WOW Festival / La Jolla Playhouse', director: 'Alicia Baskle' },
    { title: 'Becoming Cuba', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Blurred Borders', venue: 'Spain Dance Festival', director: 'Patricia Rincon' },
    { title: 'Reference to Salvador Dalí Makes Me Hot', venue: 'Moxie Theatre', director: 'Dana Harrel' },
    { title: "A Doll's House", venue: 'Old Globe Theatre', director: 'Kirsten Brandt' },
    { title: 'Playwrights Project', venue: 'Lyceum Theatre', director: 'Kaja Dun' },
  ]},
  { year: '2012', items: [
    { title: 'Words By. The Musical', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
    { title: 'Underpants', venue: 'North Coast Rep Theatre', director: 'Mark Pinter' },
    { title: 'This', venue: 'North Coast Rep Theatre', director: 'Kirsten Brandt' },
    { title: 'A Man, His Wife and His Hat', venue: 'Moxie Theatre', director: 'Janet Hayatshahi' },
    { title: 'Henry IV', venue: 'North Coast Rep Theatre', director: 'David Ellenstein' },
  ]},
  { year: '2011', items: [
    { title: 'A Raisin in the Sun', venue: 'Moxie Theatre', director: 'Delicia Turner Sonnenberg' },
    { title: 'Les Noces (ballet)', venue: 'Mandeville Theatre', director: 'Allison Green' },
    { title: 'The Great American Trailer Park Musical', venue: 'San Diego Rep', director: 'Sam Woodhouse' },
    { title: 'Hedda Gabler', venue: 'Mandell Weiss Forum', director: 'Anthony Luciano' },
    { title: 'Stereoblind (film)', venue: 'UC San Diego', director: 'Rebecca Salzer' },
  ]},
  { year: '2010', items: [
    { title: 'Generation', venue: 'Potiker Theatre / La Jolla Playhouse', director: 'Rebecca Salzer' },
    { title: "Joe Turner's Come and Gone", venue: 'Potiker / La Jolla Playhouse', director: 'Kyle Donnelly' },
    { title: 'Phantom Band', venue: 'Theodore and Adele Shank', director: 'Tom Dugdale' },
  ]},
  { year: '2009', items: [
    { title: 'Camino Real', venue: 'Potiker Theatre / La Jolla Playhouse', director: 'Adam Arian' },
    { title: 'Night', venue: 'Mandell Weiss Forum Theatre', director: 'Rebecca Salzer' },
  ]},
  { year: '2008', items: [
    { title: 'Refraction', venue: 'Theodore and Adele Shank', director: 'Jeff Wienckowski' },
    { title: "Fairy's Tale", venue: 'Mandell Weiss Forum Theatre', director: 'Patricia Rincon' },
    { title: 'The Good Doctor', venue: 'Redlands Theatre Festival', director: 'Cliff Cabanilla' },
    { title: 'La Traviata (co-design)', venue: 'University of Redlands Opera', director: 'Marco Schindelmann' },
    { title: 'Beehive. The Musical', venue: 'Redlands Theatre Festival', director: 'Cliff Cabanilla' },
    { title: 'Complete Works of W. Shakespeare', venue: 'Redlands Theatre Festival', director: 'Cliff Cabanilla' },
    { title: 'The Club Noir', venue: 'Crafton Hills College', director: 'Tom Bryant' },
  ]},
  { year: '2007', items: [
    { title: 'The Little Years', venue: 'Crafton Hills College', director: 'Tom Bryant' },
    { title: 'The Proof', venue: 'Crafton Hills College', director: 'Tom Bryant' },
    { title: 'Rosencrantz and Guildenstern Are Dead', venue: 'Crafton Hills College', director: 'Tom Bryant' },
  ]},
];

const TEACHING = [
  {
    institution: 'UC San Diego',
    role: 'Lecturer',
    period: 'September 2023 – present',
    courses: ['Advanced Costume Design TDGR 276', 'Design Studio I – Costume Design TDGR 270-B', 'Design Practicum TDGR 279'],
  },
  {
    institution: 'Academy of Art University, San Francisco',
    role: 'Part-Time Online Instructor, School of Fashion',
    period: 'January 2024 – present',
    courses: [],
  },
  {
    institution: 'Academy of Art University, San Francisco',
    role: 'Courses Writer',
    period: 'January 2024 – May 2024',
    courses: ['FSH 661 Costume Design for Theatre (graduate)'],
  },
  {
    institution: 'Academy of Art University, San Francisco',
    role: 'Costume Design Coordinator, School of Fashion',
    period: 'August 2016 – December 2023',
    courses: ['Introduction to Costume Design', 'Costume Design for Stage', 'History of Fashion', 'Drawing for Fashion', 'Costume Production for Film', 'Costume Production for Stage', 'Costume Design 1–4 (graduate)', 'Costume Design Thesis', 'Portfolio for Costume Design'],
  },
  {
    institution: 'Academy of Art University, San Francisco',
    role: 'Instructor, Adjunct Faculty',
    period: 'January 2016 – August 2016',
    courses: ['History of Fashion Arts'],
  },
  {
    institution: 'UC Santa Cruz',
    role: 'Lecturer',
    period: '2019',
    courses: ['Theater Process – Costume Design', 'Costume History'],
  },
  {
    institution: 'UC San Diego',
    role: 'Lecturer',
    period: '2011 – 2015',
    courses: ['Theater Process – Costume Design', 'Costume Design Practicum'],
  },
];

const NAV_ITEMS = [
  { id: 'cv-awards',    label: 'Awards & Honors' },
  { id: 'cv-work',      label: 'Costume Designer' },
  { id: 'cv-teaching',  label: 'Teaching' },
  { id: 'cv-education', label: 'Education' },
];

function scrollTo(id) {
  requestAnimationFrame(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top, behavior: 'smooth' });
  });
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

const ToTop = () => (
  <button className="resume-to-top" onClick={scrollToTop}>↑ Top</button>
);

const Resume = () => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleNav = (id) => {
    setMenuOpen(false);   // close menu first so layout settles
    scrollTo(id);         // scroll runs inside rAF, after the re-render
  };

  return (
  <div className="resume-page">
    <div className="resume-topbar">
      <a href="#home" className="resume-back">← Back</a>
      <a href="/AlinaBokovikovaCV.pdf" download className="resume-download">
        Download PDF →
      </a>
    </div>

    <nav className="resume-subnav">
      {/* Desktop: inline links */}
      <div className="resume-subnav-links">
        {NAV_ITEMS.map(item => (
          <button key={item.id} className="resume-subnav-link" onClick={() => scrollTo(item.id)}>
            {item.label}
          </button>
        ))}
      </div>

      {/* Mobile: burger button */}
      <button
        className={`resume-subnav-burger${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Navigation menu"
      >
        <span /><span /><span />
      </button>

      {/* Mobile: dropdown */}
      {menuOpen && (
        <div className="resume-subnav-dropdown">
          {NAV_ITEMS.map(item => (
            <button key={item.id} className="resume-subnav-dropdown-item" onClick={() => handleNav(item.id)}>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>

    <div className="resume-inner">
      <header className="resume-header">
        <div className="resume-header-label">Curriculum Vitae</div>
        <h1 className="resume-name">Alina Bokovikova</h1>
        <div className="resume-title-tag">Costume Designer &amp; Educator</div>
        <div className="resume-contact">
          <span>858-348-7174</span>
          <span className="resume-dot" />
          <a href="mailto:abokovikova@gmail.com">abokovikova@gmail.com</a>
        </div>
      </header>

      <div className="resume-rule" />

      {/* Awards */}
      <section id="cv-awards" className="resume-section">
        <h2 className="resume-section-heading">Awards &amp; Honors</h2>
        <ul className="resume-awards-list">
          {AWARDS.map((a, i) => (
            <li key={i} className="resume-award-item">
              <span className="resume-award-text">{a.text}</span>
              {a.year && <span className="resume-award-year">{a.year}</span>}
            </li>
          ))}
        </ul>
      </section>

      <div className="resume-rule" />
      <ToTop />

      {/* Productions */}
      <section id="cv-work" className="resume-section">
        <h2 className="resume-section-heading">Costume Designer</h2>
        <div className="resume-productions">
          {PRODUCTIONS.map(group => (
            <div key={group.year} className="resume-year-group">
              <div className="resume-year-label">{group.year}</div>
              <div className="resume-year-items">
                {group.items.map((item, i) => (
                  <div key={i} className="resume-prod-row">
                    <em className="resume-prod-title">{item.title}</em>
                    <span className="resume-prod-sep">·</span>
                    <span className="resume-prod-venue">{item.venue}</span>
                    <span className="resume-prod-sep">·</span>
                    <span className="resume-prod-director">Dir. {item.director}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="resume-rule" />
      <ToTop />

      {/* Teaching */}
      <section id="cv-teaching" className="resume-section">
        <h2 className="resume-section-heading">Teaching Experience</h2>
        <div className="resume-teaching-list">
          {TEACHING.map((t, i) => (
            <div key={i} className="resume-teach-item">
              <div className="resume-teach-header">
                <span className="resume-teach-institution">{t.institution}</span>
                <span className="resume-teach-period">{t.period}</span>
              </div>
              <div className="resume-teach-role">{t.role}</div>
              {t.courses.length > 0 && (
                <div className="resume-teach-courses">
                  {t.courses.join(' · ')}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <div className="resume-rule" />
      <ToTop />

      {/* Education */}
      <section id="cv-education" className="resume-section">
        <h2 className="resume-section-heading">Education</h2>
        <div className="resume-edu-list">
          <div className="resume-edu-item">
            <span className="resume-edu-degree">MFA in Costume Design</span>
            <span className="resume-edu-school">University of California, San Diego</span>
            <span className="resume-edu-year">2011</span>
          </div>
          <div className="resume-edu-item">
            <span className="resume-edu-degree">Fine Arts</span>
            <span className="resume-edu-school">Novosibirsk Art University, Russia</span>
            <span className="resume-edu-year">1999–2001</span>
          </div>
          <div className="resume-edu-item">
            <span className="resume-edu-degree">Master in Education</span>
            <span className="resume-edu-school">Novosibirsk Pedagogical University, Russia</span>
            <span className="resume-edu-year">1998</span>
          </div>
        </div>
      </section>

      <div className="resume-rule" />

      <div className="resume-footer-download">
        <a href="/AlinaBokovikovaCV.pdf" download className="resume-download-btn">
          Download Full CV (PDF) →
        </a>
      </div>
    </div>
  </div>
  );
};

export default Resume;